import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "ml-4" }
const _hoisted_2 = { class: "subtitleDashboard" }
const _hoisted_3 = {
  class: "subtitleDashboard",
  style: {"font-size":"24px !important"}
}

import { ref, computed, watch } from 'vue';
import type { PropType } from 'vue';

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
import { STRING_GENERAL } from '@/constants/labels';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useDisplay } from 'vuetify';
import HexagonMinComponent from '@/components/principalPage/hexagonMinComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';

export interface MetricPeriod {
    now: number;
    today: number;
    yesterday: number;
    twoDaysAgo: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GaugeComponent',
  props: {
    arrayItems : { 
        type: Object as PropType<MetricPeriod>, 
        default: () => ({ now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 }) 
    },
    valorCard  : { type: String, default: 'distri' }
},
  setup(__props) {

const { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
const { smAndDown } = useDisplay();

/********************************
 ********** COMPONENTS **********
 *******************************/
const props = __props;

const minValue = ref(60);
const maxValue = ref(90);
const sizeHexa = ref(120);
const sizeTitl = ref(30);
const sizeSubt = ref(13);

// watch(minValue, (valor: number) => {
//     const limitValue = ref(maxValue.value - 1);
//     if (valor >= limitValue.value && valor > 0) minValue.value = limitValue.value;
//     if (valor < 0) { minValue.value = 1; }
// });

// watch(maxValue, (valor: number) => {
//     const limitValue = ref(minValue.value + 1);
//     if (valor <= limitValue.value && valor < 100 && valor > 0) minValue.value = limitValue.value;
//     if (valor > 100) maxValue.value = 99;
// });

const valorCard = computed(() => props.valorCard);

const metricsData = computed<MetricPeriod>(() => {
    return props.arrayItems || { now: 0, today: 0, yesterday: 0, twoDaysAgo: 0 };
});

const showGraph = computed(() => !!props.arrayItems);

watch(metricsData, (newData) => {
    if (newData) {
        const okVal = newData.now.toFixed(0);
        if (valorCard.value === STRING_GENERAL.distri) store.commit('setIEODistri', okVal);
        if (valorCard.value === STRING_GENERAL.access) store.commit('setIEOAcceso', okVal);
        if (valorCard.value === STRING_GENERAL.client) store.commit('setIEOClient', okVal);
    }
}, { immediate: true, deep: true });

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    color: "bgtopology",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "pa-0" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, [
              _createTextVNode(_toDisplayString(_unref(t)('labels.ociTitle')) + " ", 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('labels.oci')), 1)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, {
        class: "pa-0",
        style: {"text-align":"-webkit-center"}
      }, {
        default: _withCtx(() => [
          (showGraph.value)
            ? (_openBlock(), _createBlock(_component_v_sheet, {
                key: 0,
                class: "gaugeClass",
                color: "transparent",
                width: _unref(smAndDown) ? '395' :'100%',
                height: "400"
              }, {
                default: _withCtx(() => [
                  _createVNode(HexagonMinComponent, {
                    class: "HexagonPos Hex1",
                    title: metricsData.value.now.toFixed(0),
                    color: 'red',
                    subtitle: _unref(t)('labels.online'),
                    minValue: minValue.value,
                    maxValue: maxValue.value,
                    "size-hexa": 160,
                    "size-title": 55,
                    "size-sub-ti": 16
                  }, null, 8, ["title", "subtitle", "minValue", "maxValue"]),
                  _createVNode(HexagonMinComponent, {
                    class: "HexagonPos Hex2",
                    title: metricsData.value.today.toFixed(0),
                    color: '',
                    subtitle: _unref(t)('labels.day'),
                    minValue: minValue.value,
                    maxValue: maxValue.value,
                    "size-hexa": sizeHexa.value,
                    "size-title": sizeTitl.value,
                    "size-sub-ti": sizeSubt.value
                  }, null, 8, ["title", "subtitle", "minValue", "maxValue", "size-hexa", "size-title", "size-sub-ti"]),
                  _createVNode(HexagonMinComponent, {
                    class: "HexagonPos Hex3",
                    title: metricsData.value.twoDaysAgo.toFixed(0),
                    color: '',
                    subtitle: '2 ' + _unref(t)('labels.day') + 's',
                    minValue: minValue.value,
                    maxValue: maxValue.value,
                    "size-hexa": sizeHexa.value,
                    "size-title": sizeTitl.value,
                    "size-sub-ti": sizeSubt.value
                  }, null, 8, ["title", "subtitle", "minValue", "maxValue", "size-hexa", "size-title", "size-sub-ti"]),
                  _createVNode(HexagonMinComponent, {
                    class: "HexagonPos Hex4",
                    title: metricsData.value.yesterday.toFixed(0),
                    color: '',
                    subtitle: 'Ayer',
                    minValue: minValue.value,
                    maxValue: maxValue.value,
                    "size-hexa": sizeHexa.value,
                    "size-title": sizeTitl.value,
                    "size-sub-ti": sizeSubt.value
                  }, null, 8, ["title", "minValue", "maxValue", "size-hexa", "size-title", "size-sub-ti"])
                ]),
                _: 1
              }, 8, ["width"]))
            : _createCommentVNode("", true),
          (!showGraph.value)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                class: "pt-5",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(Prog_circular)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})